module.exports = __webpack_public_path__ + "static/physical-purity-2979b3f8296ef6659bc16693f44145a8.png";